import {useAppDispatch, useAppSelector} from '@hooks';
import {
  NotificationCategory,
  NotificationCategoryType,
  getNotificationPreferences,
  trackEvent,
  updateNotificationPreference,
  withAsyncThunkErrorHandling,
} from '@lib/store';
import {useTranslation} from 'react-i18next';
import {StyledToggleCell} from './styles';

export const NotificationSettingsItem = ({
  category,
  type,
}: {
  category: NotificationCategory;
  type: NotificationCategoryType;
}) => {
  const {t} = useTranslation();
  const dispatch = useAppDispatch();

  const notificationPreferences = useAppSelector(getNotificationPreferences);
  const enabled = notificationPreferences[category][type];

  const handleToggle = () => {
    const next = {
      category,
      type,
      enabled: !enabled,
    };
    const trackEventAction = next.enabled ? 'EnableSetting' : `DisableSetting`;

    dispatch(withAsyncThunkErrorHandling(() => updateNotificationPreference(next)));

    dispatch(
      trackEvent(`Profile_NotificationSettings__${trackEventAction}`, {
        category,
        type,
      }),
    );
  };

  return (
    <StyledToggleCell
      label={t('profile:NotificationSettings.toggleLabel', {context: type})}
      name={`${category}${type}`}
      checked={enabled}
      onToggle={handleToggle}
    />
  );
};
